// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"246":"4aa71438","281":"383525b4"}[chunkId] + ".css";
};